import { getYesNoLabel, yesNoOptions } from '@Constants/selectOptions';
import { Column } from '@synqo/frontend-component-library';
import { ApiContainerType } from '@Model';

export const containerTypeColumns: Column<ApiContainerType>[] = [
    { name: 'shorthand', label: 'Suchcode' },
    { name: 'label', label: 'Bezeichnung' },
    { name: 'empty_weight', label: 'Leergewicht (t)' },
    {
        name: 'is_external',
        label: 'Externer Container',
        filterVariant: 'select',
        filterOptions: yesNoOptions,
        renderCell: ({ cellData }) => getYesNoLabel(cellData as boolean),
    },
    {
        name: 'uses_individual_management',
        label: 'Einzelverwaltung',
        filterVariant: 'select',
        filterOptions: yesNoOptions,
        renderCell: ({ cellData }) => getYesNoLabel(cellData as boolean),
    },
    {
        name: 'total_count',
        label: 'Gesamtbestand',
        renderCell: ({ rowData }) => renderTotalCount(rowData),
    },
];

const renderTotalCount = (containerType: ApiContainerType) =>
    containerType.uses_individual_management ? '' : containerType.total_count.toString();
